import DataGrid, { Column, Scrolling, Selection } from 'devextreme-react/cjs/data-grid';
import notistack from 'modules/core/notistack';
import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap';
import { getReturnData } from '../services/CustomerToFranchaiase.service';
import { HttpStatus } from 'modules/core';
import ReturnModal from './ReturnModal';
import ReturnBuyBack from './ReturnBuyBack';


interface CustomerToFranchiseItemsProp {
    data: any[];
    reloadDataSource(): void;
    closeModal(): void;
}


const ShowCustomerToFranchiseItems: React.FC<CustomerToFranchiseItemsProp> = ({ data, reloadDataSource, closeModal }) => {

    const [showReturnModal, setShowReturnModal] = useState(false)
    const [showBuyBackModal, setBuyBackModal] = useState(false)
    const [SelectedRows, setSelectedRows] = useState<any[]>([]);
    const [returnData, setReturnData] = useState<any>();
    const [buyBackData, setBuyBackData] = useState<any>();

    const handleReturn = async () => {
        try {
            if (!SelectedRows || SelectedRows.length === 0) {
                notistack.warning('Select the products to proceed')
                return;
            }
            const response = await getReturnData(transformedData)
            if (response.status === HttpStatus.Success) {
                setShowReturnModal(true)
                setReturnData(response.data)
                // closeModal()
                notistack.notifyFromApi(response)
            }
            else {
                notistack.notifyFromApi(response)
            }
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const handleBuyBack = async () => {
        try {
            if (!SelectedRows || SelectedRows.length === 0) {
                notistack.warning('Select the products to proceed')
                return;
            }
            const response = await getReturnData(transformedBuyBackData)
            if (response.status === HttpStatus.Success) {
                setBuyBackModal(true)
                setBuyBackData(response.data)
                notistack.notifyFromApi(response)
            }
            else {
                notistack.notifyFromApi(response)
            }
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const transformedData = {
        salesOrderId: SelectedRows?.[0]?.salesOrderId,
        returnSalesType: "Return",
        returnSalesOrderItems: SelectedRows?.map((item: any) => ({
            salesOrderItemId: item?.salesOrderItemId,
            materialTypeId: item?.materialTypeId,
            quantity: 1,
        })),
    };

    const transformedBuyBackData = {
        salesOrderId: SelectedRows?.[0]?.salesOrderId,
        returnSalesType: "BuyBack",
        returnSalesOrderItems: SelectedRows?.map((item: any) => ({
            salesOrderItemId: item?.salesOrderItemId,
            materialTypeId: item?.materialTypeId,
            quantity: 1,
        })),
    };

    const handleSelectionChange = (e: any) => {
        setSelectedRows(e.selectedRowsData);
    };

    return (
        <>
            <DataGrid
                dataSource={data}
                remoteOperations={{ groupPaging: true }}
                showRowLines={true}
                keyExpr="id"
                showBorders={true}
                onSelectionChanged={handleSelectionChange}
            >
                <Scrolling
                    mode='standard'
                    useNative={true}
                    scrollByContent={true}
                    scrollByThumb={true}
                />
                <Selection mode="multiple" />
                <Column dataField="invoiceNo" caption="Invoice No" dataType="string" width={150} />
                <Column dataField="saleOrderDate" caption="Invoice Date" dataType="date" format="dd/MM/yyyy" width={150} />

                {/* If you have Style No in API later, add it. Right now, API doesn’t return it. */}
                {/* <Column dataField="styleNo" caption="Style No" dataType="string" width={150} /> */}

                <Column dataField="categoryName" caption="Category" dataType="string" width={150} />
                <Column dataField="diaWt" caption="Dia. Wt" dataType="number" width={150} format="#,##0.000" />
                <Column dataField="diaQty" caption="Dia. Qty" dataType="number" width={150} />
                <Column dataField="netWt" caption="Net Wt" dataType="number" width={150} format="#,##0.000" />
                <Column dataField="grossWt" caption="Gross Wt" dataType="number" width={150} format="#,##0.000" />
                <Column dataField="kt" caption="Metal kt" dataType="string" width={150} />
                <Column dataField="pcs" caption="Quantity" dataType="number" width={150} />

                {/* IGI No not present in response, comment for now */}
                {/* <Column dataField="igiNo" caption="IGI NO" dataType="string" width={150} /> */}

                <Column dataField="huid" caption="HUID" dataType="string" width={150} />

                <Column
                    dataField="salesOrderFinalAmount"
                    caption="Selling Price"
                    dataType="number"
                    width={150}
                    format="#,##0.00"
                />
            </DataGrid>

            <div className='d-flex align-items-center justify-content-end gap-2 p-3'>
                <Button className='add-btn' onClick={handleBuyBack}>
                    Buy Back
                </Button>
                <Button className='submit-btn' onClick={handleReturn}>
                    Return
                </Button>
            </div>



            <Modal
                show={showReturnModal}
                onHide={() => setShowReturnModal(false)}
                className="fade"
                size="xl"
                dialogClassName="modal-dialog-centered"
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Return Item</Modal.Title>
                </Modal.Header>
                <Modal.Body
                    style={{ maxHeight: '80vh', overflowY: 'auto', padding: '5px 10px', paddingLeft: "20px" }}
                >
                    <ReturnModal returnData={returnData!} closeModal={closeModal} reloadDataSource={reloadDataSource} />
                </Modal.Body>
            </Modal>


            <Modal
                show={showBuyBackModal}
                onHide={() => setBuyBackModal(false)}
                className="fade"
                size="xl"
                dialogClassName="modal-dialog-centered"
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Buy Back Item</Modal.Title>
                </Modal.Header>
                <Modal.Body
                    style={{ maxHeight: '80vh', overflowY: 'auto', padding: '5px 10px', paddingLeft: "20px" }}
                >
                    <ReturnBuyBack returnData={buyBackData!} closeModal={closeModal} reloadDataSource={reloadDataSource} />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ShowCustomerToFranchiseItems